import { TextField } from "../../../../utils/form";

const Address = ({ form: { control }, bgColor }) => (
  <TextField
    control={control}
    name="address"
    label={bgColor ? "" : "Dirección"}
    variant="outlined"
    required
    placeholder={bgColor && "Como se mostrará en las prescripciones"}
    fullWidth
    sx={{ backgroundColor: bgColor && "#F2F9FF66" }}
  />
);

export default Address;
